import React, {useState} from 'react';
import Loader from '../../components/Loader';
import { useUser } from '../../contexts/UserContext';
import { dateFromTimestampToString } from '../../librairies/Dates';
import { useFirestoreCollection } from '../../librairies/Firestore';
import DataTable from '../table/Datatable';
import { isAdmin } from '../../contexts/UserContext';
import PrimaryButton from '../../components/buttons/PrimaryButton';
import AddItem from '../actions/AddItem';
import ToggleActivationLink from '../actions/ToggleActivationLink';
import AddChef from '../actions/AddChef';
import AddResponsable from '../actions/AddResponsable';

const Clients = () => {

  const { data: clients, loader } = useFirestoreCollection("clients");
  const [ajoutClient, popupAjoutClient] = useState(false);


  //contexte de l'utilisateur connecté
  const user = useUser();

  const columns = [
    { header: 'Nom', render: (client) => client.nom },
    { header: 'Date de création', render: (client) => dateFromTimestampToString(client.dateCreation.seconds) },
    { header: 'Active', render: (client) => (client.active ? "Activé" : "Désactivé") },
    { header: 'Action', render: (client) => (<ToggleActivationLink collection="clients" item={client} />)}
  ];

  return (
    <div>
      <div className='flex gap-2 justify-end '>
        {isAdmin(user.user) ? (
          <a href="#" onClick={() => popupAjoutClient(true)} className="justify-end flex mb-4">
            <PrimaryButton type={"button"} value={"Ajouter un client"} loading={false} />
          </a>
        ) : null }
      </div>

      {loader ? (
        <Loader />
      ) : (
        <DataTable 
          data={clients} 
          columns={columns} 
          onRowClick={(client) => window.location.href = `/client/${client.id}`}
        />
      )}

      {ajoutClient ? (
        <AddItem
          onClose={() => popupAjoutClient(false)}
          collectionPath="clients"
          title="Ajouter un client"
          fields={[{ name: "nom", label: "Nom du client", type: "text" }]}
        />
      ) : null }
    </div>
  );
};

export default Clients;
